// Determine current step from URL
export function getStepFromPath(pathname: string): number {
  if (pathname.includes('/step-3')) return 3
  if (pathname.includes('/step-2')) return 2
  if (pathname.includes('/step-1')) return 1
  return 1 // Default to step 1
}
